import { ChangeDetectionStrategy, Component, input } from "@angular/core";

import { NotificationType } from "../../../../../../apis/networkdashboard/graphql/graphql";
import { GrafanaItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/grafana/grafana-item";
import { TicketsItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/tickets/tickets-item";
import { ShortcutMenu } from "../../../../../../components/subscription-detail/shortcut-menu/shortcut-menu";
import { WiredSubscriptionDetails } from "../../../../types";

@Component({
  selector: "wired-shortcut-menu",
  templateUrl: "wired-shortcut-menu.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ShortcutMenu, TicketsItem, GrafanaItem],
})
export class WiredShortcutMenuComponent {
  protected subscription = input.required<WiredSubscriptionDetails>();
  protected activities = input.required<NotificationType[]>();
}
